@import '~style-sheet-helpers/core.less';
@import '../../order-summary-shared.module.less';

.detail-line {
  &:extend(.detail-line);
}

.total-paid-detail-line {
  display: inline-flex;
  align-items: flex-end;
}

.section-title {
  @order-summary-and-customer-recipient-title-text();
}

.icon {
  @icon();
  margin-top: 4px;
  margin-left: 8px;
  align-self: flex-end;
}
